import Swal from 'sweetalert2';
import { get_token } from '@/router';

export default {
fetch_memberships() {
            this.token_exists = get_token();
            this.isLoading = true;

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_memberships/`,
                method: "POST",
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                success: (response) => {
                    this.memberships = response.data?.memberships || [];
                    this.membership_dashboard = response.data?.dashboard || {};

        


                    this.$nextTick(() => {
                        $('.table').DataTable().destroy();  // Destroy previous instance if exists
                        $('.table').DataTable({
                            paging: true,
                            searching: true,
                            ordering: true,
                            info: true,
                            lengthChange: true,
                            pageLength: 10,
                            language: {
                                paginate: {
                                    previous: "Previous",
                                    next: "Next"
                                },
                                info: "Showing _START_ to _END_ of _TOTAL_ entries",
                                infoEmpty: "No entries available"
                            }
                        });
                    });
                },
                complete: () => {
                    this.isLoading = false;
                },
            });
        },
toggleMembership(membership){
            const previous_status = membership.is_active;
            membership.is_active = !membership.is_active;
            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/toggle_membership_status/`,
                headers: this.token_exists
                    ? {
                        Authorization: `Token ${this.getToken()}`,
                        "Content-Type": "application/json",
                    }
                    : {},
                data: JSON.stringify({
                    membership_id: membership.id,
                    is_active: membership.is_active
                }),
                success: (response) => {
                    this.handle_toggle_membership_success(response, membership);
                },
                error: (response) => {
                    this.handle_toggle_membership_error(response, membership, previous_status);
                }
            });
        },
handle_toggle_membership_success(response, membership) {
            if (response.status !== 'success') return;

            this.refresh_membership_dashboard_from_list();
            if (this.selected_manage_membership?.id === membership.id) {
                this.selected_manage_membership = membership;
            }
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Membership status updated successfully.',
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
            });
        },
handle_toggle_membership_error(response, membership, previous_status) {
            membership.is_active = previous_status;

            Swal.fire({
                icon: 'error',
                title: 'Process failed.',
                text: this.get_toggle_membership_error_message(response),
                showConfirmButton: false,
                timer: 3000,
                position: 'bottom-end',
                toast: true
            });
        },
get_toggle_membership_error_message(response) {
            const error_response_data = response.responseJSON || {};
            return error_response_data.message
                || error_response_data.error
                || 'Unable to update membership status.';
        },
open_manage_membership_modal(membership) {
            this.selected_manage_membership = membership;
            $('#manage_membership_modal').modal('show');
        },
close_manage_membership_modal() {
            $('#manage_membership_modal').modal('hide');
        },
open_manage_membership_perks(membership) {
            this.close_manage_membership_modal();
            this.open_manage_perks_modal(membership.id);
        },
open_manage_membership_users(membership) {
            this.close_manage_membership_modal();
            this.$router.push(`/view_membership_users/${membership.id}`);
        },
validateMembershipForm() {
            this.errors = {};
            this.get_membership_validation_rules()
                .filter(rule => rule.invalid())
                .forEach(rule => {
                    Reflect.set(this.errors, rule.field, rule.message);
                });

            return !Object.keys(this.errors).length;
        },
get_membership_validation_rules() {
            return [
                {
                    field: 'membership_type',
                    invalid: () => !this.membership_type,
                    message: 'Please select or enter a membership type.'
                },
                {
                    field: 'membership_price',
                    invalid: () => this.is_invalid_membership_price(),
                    message: 'Please enter a membership price greater than 0.'
                },
                {
                    field: 'billing_cycle',
                    invalid: () => !this.billing_cycle,
                    message: 'Please select a billing cycle.'
                }
            ];
        },
is_invalid_membership_price() {
            return ['', null, undefined].includes(this.membership_price)
                || Number(this.membership_price) <= 0;
        },
resetForm() {
            this.editing_membership_id = null;
            this.membership_description = '';
            this.membership_type = '';
            this.membership_price = 0;
            this.billing_cycle = '';
            this.membership_perks = [];
            this.removed_membership_perks_id = [];
            this.new_perk_name = '';
            this.errors = {};
            this.show_membership_type_dropdown = false;
        },
open_manage_perks_modal(membership_id) {
            this.selected_membership_id = membership_id;
            this.new_perk_name = '';
            this.removed_membership_perks_id = [];
            const selected_membership = this.memberships.find(
                membership => membership.id === membership_id
            );

            if (
                selected_membership &&
                Array.isArray(selected_membership.membership_perks) &&
                selected_membership.membership_perks.length > 0
            ) {
                this.membership_perks = selected_membership.membership_perks.map(item => ({
                    id: item.perk?.id || null,
                    perk: item.perk?.name || ''
                }));
            } else {
                this.membership_perks = [];
            }

            $('#manage_perks_modal').modal('show');
        },
remove_perk(index) {
            const removed_perk = Reflect.get(this.membership_perks, index);
            if (removed_perk?.id) {
                this.removed_membership_perks_id.push(removed_perk.id);
            }
            this.membership_perks.splice(index, 1);
        },
add_perk_input() {
            const perk_name = (this.new_perk_name || '').trim();
            if (!perk_name) {
                return;
            }

            this.membership_perks.push({ id: null, perk: perk_name });
            this.new_perk_name = '';
        }
};

